import {
  registerUserJourneyEventHandler,
  UserJourneyEvent,
} from '~/handlers/register-user-journey-event';
import { useUserJourneyStore } from '~/stores/apostatudo/user-journey';

/**
 * Dispara o evento `app_install` no /api/collector exatamente uma vez,
 * quando os dois sinais do AppsFlyer ja chegaram do app nativo:
 *   - conversion data com `is_first_launch === true` (handler appsflyerConversionData)
 *   - UID do device (handler appsflyerUid)
 *
 * Os dois recados vem em mensagens separadas da bridge e em ordem nao
 * garantida. Chamar esta funcao apos cada um resolve a race: quem chega
 * por ultimo fecha a condicao e dispara, sempre com `appsflyer` preenchido
 * (mandatorio pro S2S /inappevent do AppsFlyer).
 *
 * `installReported` e persistido no store, entao o replay dos recados a
 * cada boot do app nao gera disparo duplicado.
 */
export async function maybeReportAppInstall(): Promise<void> {
  const store = useUserJourneyStore();

  if (store.installReported) {
    return;
  }

  if (store.appsflyerConversionData.is_first_launch !== true) {
    return;
  }

  if (!store.appsflyer.id) {
    return;
  }

  // Marca antes do POST pra evitar disparo duplo caso o outro recado chegue
  // enquanto a requisicao esta em voo. Em falha, reverte pra permitir nova
  // tentativa no proximo sinal (ex.: replay no boot seguinte).
  store.setInstallReported(true);

  try {
    await registerUserJourneyEventHandler({
      event: UserJourneyEvent.APP_INSTALL,
      device: store.device.fingerprint
        ? { fingerprint: store.device.fingerprint }
        : undefined,
      appsflyer: {
        id: store.appsflyer.id,
        platform: store.appsflyer.platform,
        advertising_id: store.appsflyer.advertising_id,
        idfv: store.appsflyer.idfv,
        os_version: store.appsflyer.os_version,
      },
      appsflyer_conversion: { ...store.appsflyerConversionData },
    });
  } catch {
    store.setInstallReported(false);
  }
}
